import { Theme, createStyles } from '@material-ui/core';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      marginBottom: '0 !important',
    },
    titleRoot: {
      maxWidth: 350,
      width: '100%',
      whiteSpace: 'nowrap',
    },
    title: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    fieldsWrapper: {
      width: '100%',
    },
    field: {
      minWidth: spacing(5),
      marginRight: spacing(1),
      marginLeft: spacing(1),
    },
    count: {
      marginLeft: spacing(-2),
    },
    address: {
      width: '50%',

      '& > div': {
        minWidth: 100,
        maxWidth: 430,
        whiteSpace: 'nowrap',
        overflowX: 'hidden',
        textOverflow: 'ellipsis',

      }
    },
    actions: {
      justifyContent: 'flex-end',
      maxWidth: 250,
      minHeight: 54,
      '&.expanded': {
        marginRight: spacing(5),
      },
      minWidth: 'fit-content',
    },
    buttons: {
      display: 'flex',
      minWidth: 270,
      justifyContent: 'flex-end',

      '& button': {
        marginLeft: spacing(2),
      },
    },
    btnAckAll: {
      marginLeft: '0 !important',
    },
    acknowledged: {
      minWidth: 155,

      '& .icon': {
        marginRight: spacing(1),
      },
    },
    resolveBtn: {
      minWidth: 155,
      marginRight: spacing(-6),
    },
    cardSummary: {},
    cardDetails: {},
    notes: {
      display: 'flex',
      maxWidth: 90,

      '& button': {
        marginRight: spacing(5),
      },
    },
    customerInfo: {
      marginRight: spacing(2),
    }
  });
